import React from "react";

export default ({ campaignPageNumber, campaignsLength, maxCampaigns, changePage }) => {
  if (campaignsLength <= maxCampaigns) {
    return null;
  } else {
    return (
      <nav className="navbar fixed-bottom navbar-light bg-light">
        <button
          className="btn btn-danger btn-sm"
          disabled={campaignPageNumber === 0}
          onClick={() => changePage(-1)}
        >
          &laquo; Atrás
        </button>
        <span class="badge badge-light">Página: {campaignPageNumber + 1}</span>
        <button
          className="btn btn-danger btn-sm"
          disabled={
            campaignPageNumber + 1 >=
            Math.ceil(campaignsLength / (maxCampaigns))
          }
          onClick={() => changePage(1)}
        >
          Siguiente &raquo;
        </button>
      </nav>
    );
  }
};
